import { ActionTypes } from "../constants";

const reduceMessages = (state = null, action) => {
    switch (action.type) {

        case ActionTypes.GET_MESSAGES_SUCCESS:
            return action.data.map((data) => ({...data, folder: action.payload.folder}));

        case ActionTypes.GET_MESSAGE_SUCCESS:
            return [
                ...(state || []).filter(({id}) => id !== action.data.id),
                action.data
            ];

        case ActionTypes.UPDATE_MESSAGE_SUCCESS:
            return [
                ...state.filter(({id}) => Number(id) !== Number(action.payload.id)),
                {
                    ...state.find(({id}) => id === action.payload.id),
                    ...action.payload.params
                }
            ];

        case ActionTypes.DELETE_MESSAGE_SUCCESS:
            const noteId = Number(action.payload.id);
            return state.filter(({id}) => Number(id) !== noteId);

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getInboxMessages = (messages) => !messages ? [] : messages.filter(({folder}) => folder === 'inbox');
export const getMessage = (messages, messageId) => !messages ? null :  messages.find(({id}) => id === Number(messageId));

export default reduceMessages;